import { fabric } from 'fabric';
import { getPanelScale } from './get-panel-scale';
import { getPanelViewportTransform } from './get-panel-viewport-transform';

type SetSplitPanelViewportParams = {
  canvas: fabric.Canvas;
  faceType: string;
  containerWidth: number;
  containerHeight: number;
  logicalWidth: number;
  logicalHeight: number;
};

export const setSplitPanelViewport = ({
  canvas,
  faceType,
  containerWidth,
  containerHeight,
  logicalWidth,
  logicalHeight,
}: SetSplitPanelViewportParams): void => {
  const { panelScale, halfWidth } = getPanelScale({
    containerWidth,
    containerHeight,
    logicalWidth,
    logicalHeight,
  });

  canvas.setDimensions({
    width: halfWidth * panelScale,
    height: logicalHeight * panelScale,
  });

  const transform = getPanelViewportTransform({
    faceType,
    halfWidth,
    panelScale,
  });
  canvas.setViewportTransform(transform);
};
